export default "__VITE_ASSET__Cp3SRHdo__"